import { ListQuery } from "../models/ListQuery";
import { Filter } from "../models/Filter";
import { SYSNAME_TYPE } from "../constants/preset-constants";
import { appendFilter } from "./filters";
import {
    MODE_TYPE_NOT_SUPPORTED_BY_BIOMETRIC,
    MODE_TYPE_NOT_SUPPORTED_BY_BIOMETRIC_PRESET_OUTPUT,
    MODE_TYPE_SUPPORTED_BY_APERIO,
    MODE_TYPE_SUPPORTED_BY_APERIO_PRESET_OUTPUT,
    MODE_TYPE_SUPPORTED_BY_EL_LOCK,
    MODE_TYPE_SUPPORTED_BY_EL_LOCK_PRESET_OUTPUT,
    MODE_TYPE_SUPPORTED_BY_IMPROX_READER,
    MODE_TYPE_SUPPORTED_BY_IMPROX_READER_PRESET_OUTPUT,
    MODE_TYPE_SUPPORTED_BY_IO_MODULE,
    MODE_TYPE_SUPPORTED_BY_IO_MODULE_PRESET_OUTPUT
} from "../constants/mode-type";

export const getListQueryForOutputModeIds = (pSysnameType: string, listParameters?: ListQuery, ) => {
    let filters: Filter[] = listParameters?.filters || [];

    if (pSysnameType === SYSNAME_TYPE.BIOMETRIC) {
        filters = appendFilter(MODE_TYPE_NOT_SUPPORTED_BY_BIOMETRIC_PRESET_OUTPUT.map(modeSetting => modeSetting.modeTypeId).join(","), "Mode Type Id", "id", filters, "=out=");
    }
    else if (pSysnameType === SYSNAME_TYPE.IO || pSysnameType === SYSNAME_TYPE.LIFT_ELEVATOR) {
        filters = appendFilter(MODE_TYPE_SUPPORTED_BY_IO_MODULE_PRESET_OUTPUT.map(modeSetting => modeSetting.modeTypeId).join(","), "Mode Type Id", "id", filters);
    }
    else if (pSysnameType === SYSNAME_TYPE.IMPROX_READER) {
        filters = appendFilter(MODE_TYPE_SUPPORTED_BY_IMPROX_READER_PRESET_OUTPUT.map(modeSetting => modeSetting.modeTypeId).join(","), "Mode Type Id", "id", filters);
    }
    else if (pSysnameType === SYSNAME_TYPE.EL_LOCKS_ENTRY || pSysnameType === SYSNAME_TYPE.EL_LOCKS_EXIT) {
        filters = appendFilter(MODE_TYPE_SUPPORTED_BY_EL_LOCK_PRESET_OUTPUT.map(modeSetting => modeSetting.modeTypeId).join(","), "Mode Type Id", "id", filters);
    }
    else if (pSysnameType === SYSNAME_TYPE.APERIO) {
        filters = appendFilter(MODE_TYPE_SUPPORTED_BY_APERIO_PRESET_OUTPUT.map(modeSetting => modeSetting.modeTypeId).join(","), "Mode Type Id", "id", filters);
    }

    return {
        ...listParameters,
        filters: filters
    }
}

export const getListQueryForModeIds = (pSysnameType: string, listParameters?: ListQuery, ) => {
    let filters: Filter[] = listParameters?.filters || [];

    if (pSysnameType === SYSNAME_TYPE.BIOMETRIC) {
        filters = appendFilter(MODE_TYPE_NOT_SUPPORTED_BY_BIOMETRIC.map(modeSetting => modeSetting.modeTypeId).join(","), "Mode Type Id", "id", filters, "=out=");
    }
    else if (pSysnameType === SYSNAME_TYPE.IO) {
        filters = appendFilter(MODE_TYPE_SUPPORTED_BY_IO_MODULE.map(modeSetting => modeSetting.modeTypeId).join(","), "Mode Type Id", "id", filters);
    }
    else if (pSysnameType === SYSNAME_TYPE.IMPROX_READER) {
        filters = appendFilter(MODE_TYPE_SUPPORTED_BY_IMPROX_READER.map(modeSetting => modeSetting.modeTypeId).join(","), "Mode Type Id", "id", filters);
    }
    else if (pSysnameType === SYSNAME_TYPE.EL_LOCKS_ENTRY || pSysnameType === SYSNAME_TYPE.EL_LOCKS_EXIT) {
        filters = appendFilter(MODE_TYPE_SUPPORTED_BY_EL_LOCK.map(modeSetting => modeSetting.modeTypeId).join(","), "Mode Type Id", "id", filters);
    }
    else if (pSysnameType === SYSNAME_TYPE.APERIO) {
        filters = appendFilter(MODE_TYPE_SUPPORTED_BY_APERIO.map(modeSetting => modeSetting.modeTypeId).join(","), "Mode Type Id", "id", filters);
    }

    return {
        ...listParameters,
        filters: filters
    }
}

export const getListQueryForSettingIds = (presetType: string, listParameters?: ListQuery, ) => {
    let filters: Filter[] = listParameters?.filters || [];

    if (presetType === SYSNAME_TYPE.IMPROX_READER) {
        filters = appendFilter(MODE_TYPE_SUPPORTED_BY_IMPROX_READER.map(modeSetting => modeSetting.settingTypeId).join(","), "Setting Type Id", "settingType.id", filters);
    }
    else if (presetType === SYSNAME_TYPE.IO) {
        filters = appendFilter(MODE_TYPE_SUPPORTED_BY_IO_MODULE.map(modeSetting => modeSetting.settingTypeId).join(","), "Setting Type Id", "settingType.id", filters);
    }
    else if (presetType === SYSNAME_TYPE.BIOMETRIC) {
        filters = appendFilter(MODE_TYPE_NOT_SUPPORTED_BY_BIOMETRIC.map(modeSetting => modeSetting.settingTypeId).join(","), "Setting Type Id", "settingType.id", filters, "=out=");
    }
    else if (presetType === SYSNAME_TYPE.EL_LOCKS_ENTRY || presetType === SYSNAME_TYPE.EL_LOCKS_EXIT) {
        filters = appendFilter(MODE_TYPE_SUPPORTED_BY_EL_LOCK.map(modeSetting => modeSetting.settingTypeId).join(","), "Setting Type Id", "settingType.id", filters);
    }
    else if (presetType === SYSNAME_TYPE.APERIO) {
        filters = appendFilter(MODE_TYPE_SUPPORTED_BY_APERIO.map(modeSetting => modeSetting.settingTypeId).join(","), "Setting Type Id", "settingType.id", filters);
    }

    return {
        ...listParameters,
        filters: filters
    }
}
